(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rf-content-protection"] && !Shopify.designMode) return;
  try {
    (() => {
    if (!document.querySelector('meta[name="rf-content-protection"][content="enabled"]') ||
        !document.body || document.body.classList.contains('rf-content-protection')) return;

    const exceptions = 'input, textarea, select, [contenteditable]:not([contenteditable="false"]), [role="textbox"], [data-rf-allow-copy]';
    const elementFor = node => node instanceof Element ? node : node?.parentElement;
    const allowsCopy = node => Boolean(elementFor(node)?.closest(exceptions));

    document.body.classList.add('rf-content-protection');

    document.addEventListener('contextmenu', event => {
      const target = elementFor(event.target);
      const textLink = target?.closest('a[href]') && !target.closest('img');
      if (!allowsCopy(event.target) && !textLink) event.preventDefault();
    });

    document.addEventListener('dragstart', event => {
      if (!allowsCopy(event.target) && elementFor(event.target)?.closest('img')) event.preventDefault();
    });

    for (const type of ['copy', 'cut']) {
      document.addEventListener(type, event => {
        if (allowsCopy(event.target)) return;
        const selection = window.getSelection();
        if (selection && !selection.isCollapsed) {
          const start = elementFor(selection.anchorNode)?.closest(exceptions);
          const end = elementFor(selection.focusNode)?.closest(exceptions);
          if (start && start === end) return;
        }
        event.preventDefault();
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
